import styled from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  margin-top: 100px;
  display: flex;
  padding-left: 10%;
  h1 {
    color: ${Palette.PrimaryGray._900};
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: -0.8px;
    margin: 0 auto 48px;
  }
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-self: center;
`;

export const Wrap = styled.div`
  display: flex;
`;

export const ListPosition = styled.div`
  margin: 96px 32px 0 0;
  width: 205px;
`;
